interface FileValidationRules {
  maxSizeBytes: number;
  allowedTypes: string[];
  maxWidth: number;
  maxHeight: number;
  minWidth: number;
  minHeight: number;
}

export class FileValidator {
  static async validateImageFile(file: File, rules: FileValidationRules): Promise<string | null> {
    // Size validation
    if (file.size > rules.maxSizeBytes) {
      return `File too large. Max size: ${Math.round(rules.maxSizeBytes / 1024 / 1024)}MB`;
    }

    // Type validation
    if (!rules.allowedTypes.includes(file.type)) {
      return `Invalid file type. Allowed: ${rules.allowedTypes.join(', ')}`;
    }

    // Dimension validation
    const dimensions = await this.getImageDimensions(file);

    if (dimensions.width < rules.minWidth || dimensions.height < rules.minHeight) {
      return `Image too small. Min dimensions: ${rules.minWidth}x${rules.minHeight}px`;
    }

    return null; // Valid
  }

  private static getImageDimensions(file: File): Promise<{ width: number, height: number }> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(img.src);
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        reject(new Error('Failed to load image'));
      };
      img.src = URL.createObjectURL(file);
    });
  }
}

// Default validation rules
export const DEFAULT_IMAGE_VALIDATION_RULES: FileValidationRules = {
  maxSizeBytes: 10 * 1024 * 1024, // 10MB
  allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif', 'image/svg+xml'],
  maxWidth: 4096,
  maxHeight: 4096,
  minWidth: 32,
  minHeight: 32,
};